import { TypePolicies } from '@apollo/client';

export const adminCachePolicies: TypePolicies = {
  // Enforce merging this non-normalized object types
  RecommendEvent: {
    merge: true,
  },
  Date: {
    merge: true,
  },
  RegistryFulfillment: {
    merge: true,
  },
  RegistryOrderLineItemData: {
    merge: true,
  },
  MonetaryValue: {
    merge: true,
  },
  Currency: {
    merge: true,
  },
  TransferredRegistryData: {
    merge: true,
  },
  LineItem: {
    keyFields: ['locator'],
  },
  RegistryItemProductData: {
    keyFields: ['registryItem', ['id']],
  },
  RegistryItemCount: {
    merge: true,
  },
  ShippingAddress: {
    merge: true,
  },
};
